import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Icon_info",
  "use": "icon-Icon_info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Icon_info\">\n  <circle id=\"icon-Icon_info_Ellipse_32\" data-name=\"Ellipse 32\" cx=\"8\" cy=\"8\" r=\"8\" transform=\"translate(0)\" fill=\"#f5f5f5\" />\n  <g id=\"icon-Icon_info_np_info_3012852_000000\" transform=\"translate(-3.125 -3.125)\">\n    <path id=\"icon-Icon_info_Union_7\" data-name=\"Union 7\" d=\"M0,8a8,8,0,1,1,8,8A7.989,7.989,0,0,1,0,8ZM1.067,8A6.933,6.933,0,1,0,8,1.067,6.92,6.92,0,0,0,1.067,8Zm6.4,3.734v-4.8a.533.533,0,0,1,1.067,0v4.8a.533.533,0,0,1-1.067,0Zm0-6.933V3.733a.533.533,0,1,1,1.067,0V4.8a.533.533,0,1,1-1.067,0Z\" transform=\"translate(3.125 3.126)\" fill=\"#505050\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/Icon_info.svg
// module id = 90
// module chunks = 0 1 2